import { useEffect, useState } from "react";
import { BASEURL } from "../../../../constants";
import axios from "axios";
import { Resizable } from "re-resizable";
import TestThumbnail from "./TestThumbnail";
import { useParams } from "react-router-dom";
import { CrossSVG, PlusSVG, WatchSVG,LeftChevron, RightChevron } from "../../../Icons/icons";
import { closestCenter, DndContext } from "@dnd-kit/core";
import {
  SortableContext,
  rectSortingStrategy,
} from "@dnd-kit/sortable";
import { TopicSortableItem } from "./SortableItem/TopicSortableItem";
import QuestionEditor from "./Editor_Component/QuestionEditor";
import { v4 as uuidv4 } from "uuid";

const Test = ({
  validateQuestion,
  selectedTestId,
  question,
  setQuestion,
  questionsArray,
  setQuestionsArray,
  setIsDataSaved,
  setImagesArray,
  setCurrentQuestionId,
  currentQuestionId,
  numberOfQuestions,
  testTimeMinutes,
  setNumberOfQuestions,
  setTestTimeMinutes,
  imagesArray,
  autoSaveQuestion,
  selectedTopicId,
   nextQuestion,
    previousQuestion
}) => {
  const [showModal, setShowModal] = useState(false);
  const [deleteQuestionId, setDeleteQuestionId] = useState(null);

  const { courseId } = useParams();
  //how are we handling the loading and the error states
  const disableStyle = {
    pointerEvents: "none",
    color: "grey",
  };
  const newSample = {
    id: 2,
    test_id: 25,
    text: "",
    time: null,
    answer_type: "single",
    options: [],
    correct_answer: [],
    image_data: {
      image: "",
      width: "",
      height: "",
    },
    image_key: "",
    sequence: 1,
  };

  function addOption() {
    /*
            just push an empty string 
        */
    setQuestion({ ...question, options: [...question.options, { id: question.options.length + 1, text: "", image: null }] });
  }

  function handleResize(e, d, ref, delta) {
    setQuestion((question) => {
      const newQuestion = {
        ...question,
        image_data: {
          ...question.image_data,
          width: ref.style.width,
          height: ref.style.height,
        },
      };
      return newQuestion;
    });
    setIsDataSaved(false);
  }

  function handleImageUpload(event) {
    //update the img in image_data : {width , height , image : url.createObjectURL }
    //also we need to update imagesArray
    // we need to empty the imagesArray when we change between slide-group and test.
    const image = event.target.files[0];
    const url = URL.createObjectURL(image);

    event.target.value = null;
    const imageId = `question${question.id}`;
    setImagesArray((imagesArray) => {
      let newImagesArray = [...imagesArray];
      newImagesArray.push({ id: imageId, data: image });
      return newImagesArray;
    });
    setQuestion({
      ...question,
      image_data: { ...question.image_data, image: url },
      image_key: imageId,
    });
    setIsDataSaved(false);
  }
  const handleOptionImageUpload = (e, optionIndex) => {

    const file = e.target.files[0];
    if (file) {
      const reader = new FileReader();
      reader.onloadend = () => {
        const updatedOptions = [...question.options];
        updatedOptions[optionIndex].image = reader.result;
        setQuestion({ ...question, options: updatedOptions });
      };
      reader.readAsDataURL(file); // Convert image to a data URL
    }
  };

  function deleteOption(optionIndex, image_key) {
    /*
            we get the index 
            we just need to delete that [ 1 , 2 , 3 , 4 ]
        */

    if (image_key) {
      axios.delete(`${BASEURL}/api/delete-image`, {
        data: {
          key: image_key
        }
      })
    }
    const newOptionsArray = question.options.filter(
      (option, index) => optionIndex !== index
    );
    setQuestion({ ...question, options: newOptionsArray });
  }

  function saveOption(e, optionIndex) {
    //whenever user write text for an answer

    // const newOptions = [...question.options];
    // newOptions[optionIndex] = e.target.value;
    // setQuestion({ ...question, options: newOptions });
    const updatedOptions = [...question.options];
    updatedOptions[optionIndex] = { ...updatedOptions[optionIndex], text: e.target.value };

    setQuestion({
      ...question,
      options: updatedOptions,
    });

  }

  function saveCorrectAnswer(e, optionIndex) {
    //whenver user marks correct anser for the question
    //put that option into the array
    if (question.answer_type === "single") {
      //replace
      if (e.target.checked) {
        setQuestion({ ...question, correct_answer: [e.target.value] });
      } else {
        setQuestion({ ...question, correct_answer: [] });
      }
    }
    if (question.answer_type === "multiple") {
      if (e.target.checked) {
        setQuestion({
          ...question,
          correct_answer: [...question.correct_answer, e.target.value],
        });
      } else {
        const newCorrectAnswerArray = question.correct_answer.filter(
          (ans) => ans !== e.target.value
        );
        setQuestion({ ...question, correct_answer: newCorrectAnswerArray });
      }
    }
  }
  function updateQuestion(e) {
    setQuestion({ ...question, text: e.target.value });
    setIsDataSaved(false);
  }

  function handleAnswerTypeChange(e) {
    // single , multiple , audio
    /* 
            what did he switch to 
            switched to mcq 
            convert the input to radio 
            reset the correct answers will have to mark again 
            how are we going to make the inputs controlled 
            checked attribute takes true or false 
            correct_ansewer contains [{ checked : 'true' , value: 'answer'}] 
            single -- reset the correct_answer array and let user click on the correct 
        */
    setQuestion({
      ...question,
      answer_type: e.target.value,
      correct_answer: [],
    });
    setIsDataSaved(false);
  }

  function addQuestion(sequence) {
    if (!validateQuestion()) {
      // If validation fails, return early
      return;
    }

    //make api call to add question
    //add validation if the time is there and if the text is added and if the correct answer is marked then add the next question its better than no validation
    autoSaveQuestion().then((response) => {
      if (response.data.status === "successfully saved") {
        axios
          .post(`${BASEURL}/api/add-question`, {
            testId: selectedTestId,
            sequence: sequence,
            topicId: selectedTopicId,
            courseId: courseId,
          })
          .then((addQuestionResponse) => {
            //we will get the question object itself
            setQuestionsArray((questionArray) => {
              let newQuestionArray = [...questionArray];
              //find the slide index and update the content
              const questionSlideIndex = newQuestionArray.findIndex(
                (q) => q.id === question.id
              );
              newQuestionArray[questionSlideIndex] = question;
              newQuestionArray.push(addQuestionResponse.data);
              return newQuestionArray;
            });
            setQuestion(addQuestionResponse.data);
            setCurrentQuestionId(addQuestionResponse.data.id);
            //forgot to empty the images array when you auto-saved.
            setImagesArray([]);
          });
      }
    });
  }

  function handleDeleteImage() {
    if (!imagesArray.some((obj) => obj.id === `question${question.id}`)) {
      axios
        .delete(`${BASEURL}/api/delete-image`, {
          data: {
            key: `question${question.id}`,
          },
        })
        .then((response) => {
          if (response.data.message === "deleted successfully") {
            //we dont need to set questions array over here because when auto-save is triggred these changes will be stored in questionsArray.
            setQuestion({
              ...question,
              image_data: { ...question.image_data, image: "" },
              image_key: "",
            });
            setIsDataSaved(false);
          }
        });
    } else {
      setImagesArray((imagesArray) => {
        let newImagesArray = imagesArray.filter(
          (obj) => obj.id === `question${question.id}`
        );
        return newImagesArray;
      });
      setQuestion({
        ...question,
        image_data: { ...question.image_data, image: "" },
        image_key: "",
      });
    }
  }

  function deleteQuestion() {
    if (currentQuestionId === deleteQuestionId) {
      if (questionsArray.length === 1) {
        //delete then add a new question
        axios
          .delete(`${BASEURL}/api/delete-question`, {
            params: {
              questionId: deleteQuestionId,
            },
          })
          .then((response) => {
            if (response.data.status === "successfully deleted") {
              axios
                .post(`${BASEURL}/api/add-question`, {
                  testId: selectedTestId,
                  sequence: 1,
                  topicId: selectedTopicId,
                  courseId: courseId,
                })
                .then((addQuestionResponse) => {
                  const newQuestion = addQuestionResponse.data;
                  setQuestionsArray([newQuestion]);
                  setQuestion(newQuestion);
                  setCurrentQuestionId(newQuestion.id);
                  setShowModal(false);
                  setDeleteQuestionId(null);
                });
            }
          });
      } else {
        if (questionsArray[questionsArray.length - 1].id === deleteQuestionId) {
          axios
            .delete(`${BASEURL}/api/delete-question`, {
              params: {
                questionId: deleteQuestionId,
              },
            })
            .then((response) => {
              if (response.data.status === "successfully deleted") {
                const prevousQuestionIndex =
                  questionsArray.findIndex(
                    (question) => question.id === deleteQuestionId
                  ) - 1;
                setQuestion(questionsArray[prevousQuestionIndex]);
                setCurrentQuestionId(questionsArray[prevousQuestionIndex].id);
                setQuestionsArray((questionsArray) => {
                  const newQuestionsArray = questionsArray.filter(
                    (question) => question.id !== deleteQuestionId
                  );
                  return newQuestionsArray;
                });
                setShowModal(false);
                setDeleteQuestionId(null);
              }
            });
        } else {
          //move forward
          axios
            .delete(`${BASEURL}/api/delete-question`, {
              params: {
                questionId: deleteQuestionId,
              },
            })
            .then((response) => {
              if (response.data.status === "successfully deleted") {
                const nextQuestionIndex =
                  questionsArray.findIndex(
                    (question) => question.id === deleteQuestionId
                  ) + 1;
                setQuestion(questionsArray[nextQuestionIndex]);
                setCurrentQuestionId(questionsArray[nextQuestionIndex].id);
                setQuestionsArray((questionsArray) => {
                  const newQuestionsArray = questionsArray.filter(
                    (question) => question.id !== deleteQuestionId
                  );
                  return newQuestionsArray;
                });
                setShowModal(false);
                setDeleteQuestionId(null);
              }
            });
        }
      }
    } else {
      axios
        .delete(`${BASEURL}/api/delete-question`, {
          params: {
            questionId: deleteQuestionId,
          },
        })
        .then((response) => {
          if (response.data.status === "successfully deleted") {
            setQuestionsArray((questionsArray) => {
              const newQuestionsArray = questionsArray.filter(
                (question) => question.id !== deleteQuestionId
              );
              return newQuestionsArray;
            });
            setShowModal(false);
            setDeleteQuestionId(null);
          }
        });
    }
  }

  const handleOptionDragEnd = (event) => {
    const { active, over } = event;

    if (!over) return; // Exit if no valid drop target.

    const activeIndex = parseInt(active.id, 10); // Convert `active.id` to integer.
    const overIndex = parseInt(over.id, 10); // Convert `over.id` to integer.

    if (activeIndex !== overIndex) {
      // Reorder the options array.
      const reorderedOptions = Array.from(question.options);
      const [removed] = reorderedOptions.splice(activeIndex, 1);
      reorderedOptions.splice(overIndex, 0, removed);

      // Update the state with the new order.
      setQuestion((prevQuestion) => ({
        ...prevQuestion,
        options: reorderedOptions,
      }));
    }
  };
  const handleOptionImageChange = (index, newImage, uniqueId) => {
    const updatedOptions = [...question.options];
    updatedOptions[index] = { ...updatedOptions[index], image: newImage, imageKey: uniqueId };

    setQuestion({
      ...question,
      options: updatedOptions,
    });
  };


  const handleUploadOptionImages = async (e, optionIndex) => {
    const file = e.target.files[0];
    if (file) {

      const uniqueId = uuidv4();
      const formData = new FormData();
      formData.append('image', file);
      formData.append('id', uniqueId);
      const response = await axios.post(`${BASEURL}/api/upload-image`, formData, {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      });
      const reader = new FileReader();
      reader.onloadend = () => {
        handleOptionImageChange(optionIndex, reader.result, uniqueId); // Set the image as a base64 string
      };
      reader.readAsDataURL(file);

    }
  }


  useEffect(() => {
    async function fetchOptionImageUrl(data) {
      const imagesPromiseArray = []
      const indexArray = []

      data?.options?.forEach(async (optionObject, index) => {

        if (optionObject.imageKey) {
          const imagePromise = axios.get(`${BASEURL}/api/get-image`, {
            params: {
              imageId: optionObject.imageKey,
              index: index
            }
          })
          imagesPromiseArray.push(imagePromise)
          indexArray.push(index)
        }

      })

      const promiseResponse = await Promise.all(imagesPromiseArray)
      promiseResponse.map((resObj, index) => {
        // { options : [ { image: url }]}
        const replaceIndex = indexArray[index]
        data.options[replaceIndex] = { ...data.options[replaceIndex], image: resObj.data.dataUrl }
      })

      setQuestion(data);
    }
    if (question) {

      fetchOptionImageUrl(question)
    }


  }, []);


  const handleDeleteOptionImage = (optionIndex, image_key) => {

    if (image_key) {
      axios.delete(`${BASEURL}/api/delete-image`, {
        data: {
          key: image_key
        }
      })
      let newOption = question.options.map((option, index) => {
        if (optionIndex === index) {
          return { ...option, imageKey: "", image: null }
        } else {
          return option
        }
      })

      setQuestion({ ...question, options: newOption })
    }

  }




  return (
    <>
      {showModal && (
        <div
          className="relative  z-30"
          aria-labelledby="modal-title"
          role="dialog"
          aria-modal="true"
        >
          <div className="fixed  inset-0 bg-gray-500 bg-opacity-75 transition-opacity"></div>

          <div className="fixed h-full  inset-0 z-10 w-screen overflow-y-auto">
            <div className="flex min-h-full h-full items-center justify-center p-4 text-center sm:items-center sm:p-0">
              <div
                style={{ minWidth: "20%" }}
                className="relative p-3 h-auto transform flex-col justify-evenly rounded-lg bg-white text-left shadow-xl transition-all my-8"
              >
                <div className="flex w-full justify-center">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    fill="none"
                    viewBox="0 0 24 24"
                    strokeWidth={1.5}
                    stroke="currentColor"
                    className="size-10"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      d="M12 9v3.75m9-.75a9 9 0 1 1-18 0 9 9 0 0 1 18 0Zm-9 3.75h.008v.008H12v-.008Z"
                    />
                  </svg>
                </div>
                <div className="flex justify-center py-2 px-3">
                  <span className="font-bold">Are you sure?</span>
                </div>
                <div className="flex justify-center py-2 px-3">
                  <span className="text-xs text-gray-600">
                    Do you really want to delete this?This action cannot be
                    undone.
                  </span>
                </div>
                <div className="flex justify-around">
                  <button
                    className="px-3 py-1 border-2 border-gray-300 rounded-lg text-gray-500 text-xs"
                    onClick={() => {
                      setShowModal(false);
                    }}
                  >
                    Cancel
                  </button>
                  <button
                    onClick={() => {
                      deleteQuestion();
                    }}
                    className="px-3 py-1 bg-slate-500 text-white rounded-lg text-xs"
                  >
                    Yes, Delete it!
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
      {questionsArray ? (
        <section
          className="flex flex-col w-full items-center h-full overflow-auto"
          style={{ width: "100%" }}
        >
          <div className="flex w-full p-2 px-6 items-center justify-between border-b">
            <div className="flex gap-x-3 w-full overflow-x-scroll pt-2 pb-1">
              {questionsArray
                ? questionsArray.map((q, index) => {
                  return (
                    <TestThumbnail
                      validateQuestion={validateQuestion}
                      key={index}
                      autoSaveQuestion={autoSaveQuestion}
                      setShowModal={setShowModal}
                      setDeleteQuestionId={setDeleteQuestionId}
                      setCurrentQuestionId={setCurrentQuestionId}
                      q={q}
                      question={question}
                      currentQuestionId={currentQuestionId}
                      index={index}
                      setQuestionsArray={setQuestionsArray}
                      questionsArray={questionsArray}
                      setQuestion={setQuestion}
                    />
                  );
                })
                : null}
              <div
                onClick={() => {
                  addQuestion(
                    questionsArray[questionsArray.length - 1].sequence + 1
                  );
                }}
                className="shrink-0 flex justify-center bg-white items-center ml-2 w-10 h-10"
                style={{
                  cursor: "pointer",
                  overflow: "hidden",
                  border: "1px solid #E0E0E0",
                  backgroundColor: "rgba(224, 224, 224, 0.30)",
                }}
              >
                <PlusSVG />
              </div>
            </div>
            <div className="flex items-center justify-center gap-2 shrink-0">
              {/* <label className="text-xs">No. of questions to display during test</label> <input value={numberOfQuestions} onChange={(e) => setNumberOfQuestions(e.target.value)} className="p-1 text-xs border-2 border-solid border-gray-400 rounded-lg w-12" type="number"></input> */}
              <label className="text-sm">Time for the test:</label>
              <div className="flex gap-2 items-center border border-[#E0E0E0] p-1">
                <WatchSVG />
                <input
                  value={testTimeMinutes}
                  onChange={(e) => {
                    setTestTimeMinutes(e.target.value);
                  }}
                  className="p-1 text-xs w-20 outline-none"
                  type="number"
                  min={null}
                  placeholder="Minutes"
                ></input>
                {/* <spna className="text-xs">Minutes</spna> */}
              </div>
            </div>
            <div className="flex items-center pl-5 gap-2 ml-auto">
              <span
                onClick={previousQuestion}
                className="flex items-center justify-center cursor-pointer border border-[#E0E0E0] w-[40px] h-[40px]"
              >
                <LeftChevron />
              </span>
              <span
                onClick={nextQuestion}
                className="flex items-center justify-center cursor-pointer border border-[#E0E0E0] w-[40px] h-[40px]"
              >
                <RightChevron />
              </span>
            </div>
          </div>

          <div className="min-h-min w-full flex justify-center py-0 relative overflow-auto pb-7 ">
            {question ? (
              <div className="w-full max-w-[1000px] p-4 mt-4 border rounded shadow-xl pb-5">
                <div className="flex space-x-2 mb-4">
                  <label className="flex items-center space-x-2">
                    <input
                      type="radio"
                      name="answerType"
                      value="single"
                      className="text-red-500 focus:ring-red-500"
                      onChange={handleAnswerTypeChange}
                      checked={question.answer_type === "single"}
                    />
                    <span className="text-xs">Single correct</span>
                  </label>
                  <label className="flex items-center space-x-2">
                    <input
                      type="radio"
                      name="answerType"
                      value="multiple"
                      className="text-red-500 focus:ring-red-500"
                      onChange={handleAnswerTypeChange}
                      checked={question.answer_type === "multiple"}
                    />
                    <span className="text-xs">Multiple correct</span>
                  </label>
                  {/* Uncomment below for additional options */}
                  {/* <label className="flex items-center space-x-2">
    <input
      type="radio"
      name="answerType"
      value="audio"
      className="text-red-500 focus:ring-red-500"
      onChange={handleAnswerTypeChange}
      checked={question.answer_type === "audio"}
    />
    <span className="text-xs">Audio</span>
  </label> */}
                </div>

                {/* <textarea
                  rows={4}
                  className="w-full mb-1 border p-1 text-xs outline-none"
                  placeholder={
                    question.answer_type === "audio"
                      ? "Type a sentence you want student to read"
                      : "Enter your question"
                  }
                  value={question.text}
                  onChange={(e) => {
                    updateQuestion(e);
                  }}
                ></textarea> */}
                <QuestionEditor key={question.id} data={question.text} setQuestion={setQuestion} setIsDataSaved={setIsDataSaved} />
                <div className="flex justify-between items-center mb-2">
                  {/* <div
                    className={`${
                      question.image_data.image ? "invisible" : "visible"
                    }`}
                  >
                    <label
                      className="text-gray-500 text-xs"
                      style={{ color: "#6b7280" }}
                      htmlFor={`mcq-image${question.id}`}
                    >
                      <i
                        style={{ cursor: "pointer" }}
                        className="fa-regular fa-image"
                      ></i>
                      {`Add Image (Optional)`}
                    </label>
                    <input
                      type="file"
                      accept="image/*"
                      id={`mcq-image${question.id}`}
                      onChange={(event) => handleImageUpload(event)}
                      style={{ display: "none" }}
                    ></input>
                  </div> */}
                  <div
                    className={`${question.image_data.image ? "invisible" : "visible"
                      } border-2 border-dashed border-gray-300  p-1`}
                  >
                    <label
                      className="text-gray-500 text-sm flex items-center justify-center space-x-2 cursor-pointer"
                      htmlFor={`mcq-image${question.id}`}
                    >
                      <i className="fa-regular fa-image text-xl"></i>
                      <span className="text-xs font-bold">Add Image</span>
                    </label>
                    <input
                      type="file"
                      accept="image/*"
                      id={`mcq-image${question.id}`}
                      onChange={(event) => handleImageUpload(event)}
                      style={{ display: "none" }}
                    />
                  </div>

                  {/* <select
                    className="text-xs"
                    onChange={handleAnswerTypeChange}
                    value={question.answer_type}
                  >
                    <option value={"single"}>Single correct</option>
                    <option value={"multiple"}>Multiple correct</option>
                    {/* <option value={"audio"}>Audio</option> */}
                  {/* </select>  */}
                </div>
                {question.image_data.image ? (
                  <div className="w-4/5 flex gap-2 justify-between">
                    <Resizable
                      className="border mb-2"
                      size={{
                        width: question.image_data.width,
                        height: question.image_data.height,
                      }}
                      maxWidth="100%"
                      style={{
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                      }}
                      lockAspectRatio={false}
                      onResizeStop={(e, d, ref, delta) =>
                        handleResize(e, d, ref, delta)
                      }
                    >
                      <img
                        src={question.image_data.image}
                        style={{  width: "50%" }}
                      ></img>
                    </Resizable>
                    <i
                      style={{ cursor: "pointer" }}
                      onClick={handleDeleteImage}
                      className="fa-regular fa-circle-xmark"
                    ></i>
                  </div>
                ) : null}
                {question.answer_type !== "audio" ? (
                  <>
                    <section
                      className="text-xs grid grid-cols-2 gap-4"
                    >

                      <DndContext
                        collisionDetection={closestCenter}
                        onDragEnd={handleOptionDragEnd} // Handle the drag end event for options
                      >
                        <SortableContext
                          items={question.options.map((_, index) =>
                            index.toString()
                          )}
                          strategy={rectSortingStrategy}
                        >
                          {question.answer_type === "single" || question.answer_type === "multiple"
                            ? question.options.map((option, optionIndex) => {
                              const isChecked = question.correct_answer.some(
                                (answer) => answer.value === option.id
                              );

                              return (
                                <TopicSortableItem
                                  key={optionIndex}
                                  id={optionIndex.toString()}
                                >
                                  <div className="w-full">

                                    <div
                                      className="flex gap-1 h-[40px] w-full border border-solid border-gray-300 items-center px-2 py-0"
                                      key={`${question.id}-optionIndex`}
                                    >
                                      {/* Label with border */}
                                      <span className="flex items-center pr-2 border-r border-solid border-gray-300 h-full text-[16px] text-gray-500">
                                        {`${String.fromCharCode(65 + optionIndex)}`}
                                      </span>

                                      {/* Input type: radio or checkbox */}
                                      <input
                                        key={`${question.id}${optionIndex}`}
                                        className="text-xl"
                                        type={question.answer_type === "single" ? "radio" : "checkbox"}
                                        disabled={!option.text}
                                        value={option.id}
                                        checked={isChecked}
                                        name="answer"
                                        onChange={() => {
                                          // Handle correct answer change
                                          setQuestion((prev) => {
                                            let updatedCorrectAnswers = [...prev.correct_answer];

                                            if (prev.answer_type === "single") {
                                              updatedCorrectAnswers = [{ checked: true, value: option.id }];
                                            } else if (prev.answer_type === "multiple") {
                                              const existingIndex = updatedCorrectAnswers.findIndex(
                                                (answer) => answer.value === option.id
                                              );
                                              if (existingIndex !== -1) {
                                                updatedCorrectAnswers.splice(existingIndex, 1); // Remove if already selected
                                              } else {
                                                updatedCorrectAnswers.push({
                                                  checked: true,
                                                  value: option.id,
                                                });
                                              }
                                            }

                                            return {
                                              ...prev,
                                              correct_answer: updatedCorrectAnswers,
                                            };
                                          });

                                          setIsDataSaved(false);
                                        }}
                                      />

                                      {/* Option input field */}
                                      <input
                                        className="w-full outline-none text-xs" // Ensure it takes up full available width
                                        type="text"
                                        placeholder={`Answer ${optionIndex + 1}`}
                                        value={option.text}
                                        onChange={(e) => {
                                          saveOption(e, optionIndex);
                                        }}
                                      />



                                      {/* Image upload icon */}
                                      <div className="cursor-pointer pl-2 mr-1 border-l border-solid border-gray-300 h-[40px] flex items-center">
                                        <label htmlFor={`image-upload-${optionIndex}`}>
                                          <i className="fa-regular fa-image text-lg"></i>
                                        </label>
                                        <input
                                          type="file"
                                          id={`image-upload-${optionIndex}`}
                                          accept="image/*"
                                          style={{ display: "none" }}
                                          onChange={(e) =>
                                            handleUploadOptionImages(e, optionIndex)
                                          }
                                        />
                                      </div>

                                      {/* Delete icon with border */}
                                      <div
                                        className="cursor-pointer pl-2 border-l border-solid border-gray-300 h-[40px] flex items-center"
                                        onClick={() => {
                                          deleteOption(optionIndex, option.imageKey);
                                        }}
                                      >
                                        <CrossSVG />
                                      </div>
                                    </div>

                                    {option.image && (
                                      <>
                                        <div className="relative mt-2 h-24 w-24 border border-solid border-gray-300 overflow-hidden">
                                          <i
                                            style={{ cursor: 'pointer' }}
                                            onClick={() => handleDeleteOptionImage(optionIndex, option.imageKey)}
                                            className="fa-regular fa-circle-xmark absolute top-0 right-0 text-red-500 text-lg"
                                          ></i>
                                          <div className="flex items-center justify-center h-full w-full">
                                            <img
                                              src={option.image}
                                              alt={`Option ${optionIndex}`}
                                              className="w-full h-full object-contain p-[px]"
                                            />
                                          </div>
                                        </div>

                                      </>
                                    )}

                                  </div>
                                </TopicSortableItem>
                              );
                            })
                            : null}

                        </SortableContext>
                      </DndContext>
                    </section>

                    <div className="flex justify-between mt-4">
                      <div className="flex justify-start py-2">
                        <a
                          className="text-blue-500 text-xs flex items-center justify-center cursor-pointer hover:text-gray-500"
                          onClick={addOption}
                        >
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            fill="none"
                            viewBox="0 0 24 24"
                            stroke-width="1.5"
                            stroke="currentColor"
                            class="size-4"
                          >
                            <path
                              stroke-linecap="round"
                              stroke-linejoin="round"
                              d="M12 4.5v15m7.5-7.5h-15"
                            />
                          </svg>
                          <span className="ml-1">Add answers</span>
                        </a>
                      </div>
                      <div className="flex mb-2">
                        {/* <div
                          //   onClick={handleOpenModal}
                          className=" mr-2 transition-transform duration-200 hover:-translate-y-0.5 hover:bg-[#1F1A4C] flex gap-1 px-3 py-2 bg-customPrimaryPurple text-white cursor-pointer"
                        >
                          <button className="text-sm font-normal">close</button>
                        </div> */}
                        <div
                          //   onClick={handleOpenModal}
                          className="transition-transform duration-200 hover:-translate-y-0.5 hover:bg-[#1F1A4C] flex gap-1 px-3 py-2 bg-customPrimaryPurple text-white cursor-pointer "
                        >
                          <button
                            className="text-sm font-normal"
                            onClick={() => {
                              addQuestion(
                                questionsArray[questionsArray.length - 1]
                                  .sequence + 1
                              );
                            }}
                          >
                            Save & Next
                          </button>
                        </div>
                      </div>
                    </div>
                  </>
                ) : null}
              </div>
            ) : null}
          </div>
        </section>
      ) : null}
    </>
  );
};

export default Test;
